import React from "react";
import PropTypes from "prop-types";
import { renderColumn } from "./helpers";

const PopulationFrequenciesTotalRow = ({
  rowLabel,
  emptyColumn,
  alleleCount,
  alleleNumber,
  heteroplasmic,
  homozygotes,
  hemizygotes,
  alleleFrequency,
}) => {
  return (
    <tr
      key={`${rowLabel}_totals`}
      className={`varsome-table-totals ${
        rowLabel !== "Total" ? "gnomad-font-normal" : ""
      }`}
    >
      {renderColumn(
        "row-label-total",
        rowLabel,
        `tw-w-17$ ${rowLabel !== "Total" ? "tw-text-right" : ""}`
      )}
      {renderColumn("empty-column-total", emptyColumn, "tw-w-13/100")}
      {renderColumn(
        "allele-count-total",
        alleleCount,
        "tw-w-13/100 tw-text-right"
      )}
      {renderColumn(
        "allele-number-total",
        alleleNumber,
        "tw-w-13/100 tw-text-right"
      )}
      {heteroplasmic &&
        renderColumn(
          "heteroplasmic-total",
          heteroplasmic,
          "tw-w-12/100 tw-text-right"
        )}
      {renderColumn(
        "homozygotes-total",
        homozygotes,
        "tw-w-12/100 tw-text-right"
      )}
      {hemizygotes &&
        renderColumn(
          "hemizygotes-total",
          hemizygotes,
          "tw-w-12/100 tw-text-right"
        )}
      <td
        className="gnomad-af-td-padding tw-w-21/100"
        data-testid="allele-frequency-total"
      >
        {alleleFrequency || "-"}
      </td>
    </tr>
  );
};

PopulationFrequenciesTotalRow.propTypes = {
  rowLabel: PropTypes.string,
  emptyColumn: PropTypes.number,
  alleleCount: PropTypes.number,
  alleleNumber: PropTypes.number,
  heteroplasmic: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  homozygotes: PropTypes.number,
  hemizygotes: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  alleleFrequency: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

PopulationFrequenciesTotalRow.defaultProps = {
  rowLabel: null,
  emptyColumn: null,
  alleleCount: null,
  alleleNumber: null,
  heteroplasmic: null,
  homozygotes: null,
  hemizygotes: null,
  alleleFrequency: null,
};

export default PopulationFrequenciesTotalRow;
